// import { normalize } from 'normalizr'
import * as R from 'ramda'
import * as School from 'models/schools'
// import MOCK_DISTRICT_DATA from 'mock/districts'
// import { districtSchema } from '../schemas'

export const REQUEST_DISTRICT_SCHOOLS = 'REQUEST_DISTRICT_SCHOOLS'
export const RECEIVE_DISTRICT_SCHOOLS = 'RECEIVE_DISTRICT_SCHOOLS'
export const RETRIEVE_DISTRICT_SCHOOLS_FROM_CACHE =
  'RETRIEVE_DISTRICT_SCHOOLS_FROM_CACHE'
export const REQUEST_ONE_SCHOOL = 'REQUEST_ONE_SCHOOL'
export const RECEIVE_ONE_SCHOOL = 'RECEIVE_ONE_SCHOOL'
export const RECEIVE_ERROR = 'schools/RECEIVE_ERROR'

const receiveError = error => ({
  type: RECEIVE_ERROR,
  error
})

// const isCached = (lastUpdated, cacheDuration) =>
//   Date.now() - lastUpdated <= cacheDuration

const requestOneSchool = schoolId => ({
  type: REQUEST_ONE_SCHOOL,
  schoolId
})

const receiveOneSchool = (schoolId, school, district) => ({
  type: RECEIVE_ONE_SCHOOL,
  schoolId,
  school,
  district,
  receivedAt: Date.now()
})

export const fetchOneSchool = schoolId => dispatch => {
  dispatch(requestOneSchool(schoolId))
  return School.getOne(schoolId)
    .then(json => {
      const school = R.omit(['district'], json)
      school.district_id = json.district.district_id
      school.flyers = []
      const district = {
        ...json.district,
        flyers: [],
        schools: [school.school_id]
      }
      return dispatch(receiveOneSchool(schoolId, school, district))
    })
    .catch(err => dispatch(receiveError(err)))
}



// WEBPACK FOOTER //
// ./src/shared/redux/schools/actions.js